
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nse5834db20214ddb8fe27f05e9c9216d5en from './en.yaml'
            i18n.addResourceBundle('en', 'e5834db20214ddb8fe27f05e9c9216d5', flattenObject(nse5834db20214ddb8fe27f05e9c9216d5en), true, true);
        
        export default 'e5834db20214ddb8fe27f05e9c9216d5';
    